module.exports = __webpack_public_path__ + "img/icn_cold_active.92bc62a8.svg";